import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import CloseBrowserTabDetector from '../../services/common/closeBrowserTabDetector';

const CloseTabReactItemFormDetector = () => {
  const { formState: { isDirty } } = useFormContext();

  useEffect(() => {
    const closeBrowserTabDetector = new CloseBrowserTabDetector({});
    if (isDirty) {
      closeBrowserTabDetector.init();
    }

    return () => {
      if (isDirty) {
        closeBrowserTabDetector.destroy();
      }
    };
  }, [isDirty]);

  return null;
};

export default CloseTabReactItemFormDetector;
